import React, { useState } from "react";
import { Box, Flex, SimpleGrid, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import timePicker from "../../../../assets/JSON/timepicker.json";
import { MediumBtn } from "common/components/Buttons/MediumBtn";
import { NavLink } from "react-router-dom";
import { useField } from "formik";
import { formSteps } from "common/enums/formSteps";
function TimePicker({
  value,
  setStep,
  name,
}: {
  value: string;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  name: string;
}) {
  const timePickerData = timePicker;
  //const navigate = useNavigate();
  const cancelClickHandler = () => {
    setStep(formSteps.initial);
  };
  const [clickedTime, setClickedTime] = useState<string>("" + value);

  const [field, meta, { setValue }] = useField(name);

  return (
    <Flex className="timePicker-container">
      <SimpleGrid
        columns={{ sm: 2, md: 4, lg: 4, xl: 4 }}
        className="timePicker-box"
      >
        {timePicker.map(
          (time: { id: number; time: string; status: boolean }) => (
            <Flex
              justifyContent="center"
              key={time.id}
              onClick={(event) => {
                const selectedTimeId = (event.target as HTMLElement).dataset.id;

                console.log("timepicker event selectedTimeId", selectedTimeId);

                const isTimeActive = timePicker.find(
                  (timeObj) => "" + timeObj.id === selectedTimeId
                )?.status;

                if (isTimeActive && selectedTimeId) {
                  setValue(selectedTimeId);
                  setClickedTime(selectedTimeId);
                }
              }}
            >
              <Box
                className={`${
                  time.status ? "timePicker" : "timePicker-fullTime"
                } ${"" + time.id === clickedTime ? "clicked" : ""} `}
                key={time.id}
                data-id={time.id}
              >
                {time.time}
              </Box>
            </Flex>
          )
        )}
      </SimpleGrid>
    </Flex>
  );
}

export default TimePicker;
